/**
 * @file useDra
 */
import { useRefCallback, useSafeInit, useSingleton } from '@tencent/glue-react-use';
import { useCallback } from 'react';
import { Drag } from '@tencent/glue-dom-drag';
export function useDrag(options) {
  var draggable = options.draggable,
      trigger = options.trigger,
      data = options.data,
      onDragPrepare = options.onDragPrepare,
      onDragStart = options.onDragStart,
      onDragging = options.onDragging,
      onDragEnd = options.onDragEnd,
      onClick = options.onClick;
  var drag = useSingleton(function () {
    return new Drag();
  });
  var handleDragPrepare = useRefCallback(onDragPrepare);
  var handleDragStart = useRefCallback(onDragStart);
  var handleDragging = useRefCallback(onDragging);
  var handleDragEnd = useRefCallback(onDragEnd);
  var handleClick = useRefCallback(onClick);
  drag.updateOptions({
    draggable: draggable,
    trigger: trigger,
    data: data
  });
  var ref = useCallback(function (elem) {
    return drag.init(elem);
  }, []);
  useSafeInit(function () {
    drag.addListener('drag-prepare', handleDragPrepare);
    drag.addListener('drag-start', handleDragStart);
    drag.addListener('dragging', handleDragging);
    drag.addListener('drag-end', handleDragEnd);
    drag.addListener('click', handleClick);
    return function () {
      drag.removeListener('drag-prepare', handleDragPrepare);
      drag.removeListener('drag-start', handleDragStart);
      drag.removeListener('dragging', handleDragging);
      drag.removeListener('drag-end', handleDragEnd);
      drag.removeListener('click', handleClick);
      drag.dispose();
    };
  });
  return [ref, drag];
}